import { createCustomAction } from 'typesafe-actions';

import {
  standardEmptyACC,
  standardFailedACC,
  standardFlowACC,
} from '../../utils/sagas';

const REQUESTED = '$FETCH_MAX_ORDER_VALUE_RULES/REQUESTED';
const BLOCKED = '$FETCH_MAX_ORDER_VALUE_RULES/BLOCKED';
const APPROVED = '$FETCH_MAX_ORDER_VALUE_RULES/APPROVED';
const SUCCEEDED = '$FETCH_MAX_ORDER_VALUE_RULES/SUCCEEDED';
const FAILED = '$FETCH_MAX_ORDER_VALUE_RULES/FAILED';

const request = <T>(type: T) => {
  // prettier-ignore
  return standardFlowACC<
    T,
    { }>(type);
};

const succeed = <T>(type: T) => {
  // prettier-ignore
  return standardFlowACC<
    T,
    { }>(type);
};

export const events = {
  REQUESTED,
  BLOCKED,
  APPROVED,
  SUCCEEDED,
  FAILED,
};

export const actions = {
  requested: createCustomAction(REQUESTED, request),
  approved: createCustomAction(APPROVED, request),
  blocked: createCustomAction(BLOCKED, standardEmptyACC),
  succeeded: createCustomAction(SUCCEEDED, succeed),
  failed: createCustomAction(FAILED, standardFailedACC),
};

export default actions.requested;
